import React, { useEffect, useState, useContext, useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { CardScanView } from '@cardscan.ai/insurance-cardscan-react';
import { setShowRightSidedBannerVisibility, setIsFetching } from '../actions';
import CardscanErrorModal from '../components/CardscanErrorModal';
import useCardScan from '../hooks/useCardScan';
import { CardscanContext } from '../utils/context';
import { TrackInsuranceCardScan } from '../actions/segment';
import { ROUTES } from '../constants/routes';
import { PATIENT_INSURANCE_STATUS } from '../constants/patient';
import usePatientAPI from '../hooks/usePatientAPI';

const CardScanRoute = ({
  setShowRightSidedBannerVisibility,
  setIsFetching,
  TrackInsuranceCardScan
}) => {
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [sessionToken, setSessionToken] = useState();
  const { authCardScan, parseCardData, getCard } = useCardScan(() => {}, showErrorState);
  const history = useHistory();
  const { customPatientUpdate } = usePatientAPI();
  const [, setInsuranceInformation] = useContext(CardscanContext)

  useEffect(() => {
    setIsFetching(true);
    setShowRightSidedBannerVisibility(true);

    (async () => {
      const token = await authCardScan();
      if (!token) {
        showErrorState('Could not retrieve cardscan access token');
      } else {
        setSessionToken(token);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (sessionToken || showErrorModal) setIsFetching(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionToken, showErrorModal]);

  useLayoutEffect(() => {
    TrackInsuranceCardScan();
    // eslint-disable-next-line
  }, []);

  function showErrorState(error) {
    console.error(error);
    setIsFetching(false);
    setShowErrorModal(true);
  }

  async function onScanSuccess (data) {
    try {
      const card = await getCard(sessionToken, data.cardId);
      setInsuranceInformation(parseCardData(card));
      setShowRightSidedBannerVisibility(false);
      history.replace('/policy-holder');
    } catch (error) {
      showErrorState('Error retrieving card data');
    }
  }

  const handleSkipInsuranceInfoClick = async () => {
    setShowErrorModal(false);
    try {
      setIsFetching(true);
      await customPatientUpdate({
        insurance_card_status: PATIENT_INSURANCE_STATUS.SKIPPED,
      });
      setIsFetching(false);
      setShowRightSidedBannerVisibility(false);
      history.replace(ROUTES.FIRST_APPT_OVERVIEW, { skipInsurance: true });
    } catch (error) {
      console.log('Error updating insurance card status to skipped', error);
      setIsFetching(false);
    }
  };

  const handleCancelInsuranceInfoClick = async () => {
    history.replace(ROUTES.INSURANCE_INFO);
  }

  if (showErrorModal) {
    return <CardscanErrorModal
      onSkip={handleSkipInsuranceInfoClick}
      onRetry={handleCancelInsuranceInfoClick}
    />;
  }

  return sessionToken ? (
      <CardScanView
        live
        sessionToken={sessionToken}
        backsideSupport
        onSuccess={onScanSuccess}
        onError={error => showErrorState(error)}
        onCancel={handleCancelInsuranceInfoClick}
      />
  ) : null;
};

export default connect(null, {
  setShowRightSidedBannerVisibility,
  setIsFetching,
  TrackInsuranceCardScan,
})(CardScanRoute);